<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="$apollo.loading"
    :items-per-page-options="[10, 25, 50, 100]"
    :search="search"
    v-bind="pagingOptions"
    :hide-default-footer="hideFooter"
  >
    <template v-slot:item.validFrom="{ item }">{{
      item.validFrom | formatDate
    }}</template>
    <template v-slot:item.validTo="{ item }">{{
      item.validTo | formatDate
    }}</template>
    <template v-slot:item.bookBeforeDate="{ item }">{{
      item.bookBeforeDate | formatDate
    }}</template>
    <template v-slot:item.actions="{ item }">
      <default-list-actions
        :item="item"
        :hide-view="true"
        @deleteItem="deleteItem($event)"
        @editItem="editItem($event)"
        :hide-remove="$store.getters.hasAccessTo('suppliers:view_only')"
        :hide-edit="$store.getters.hasAccessTo('suppliers:view_only')"
      ></default-list-actions>
    </template>
  </v-data-table>
</template>

<script>
import DefaultListActions from "../../shared/DefaultListActions";
import { pagingOptions } from "../../../../helpers/index";
export default {
  name: "discounts-table",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    hideFooter: {
      type: Boolean,
      defaultd: () => false,
    },
  },
  components: { DefaultListActions },
  data() {
    return {
      pagingOptions,
    };
  },
  methods: {
    deleteItem(payload) {
      this.$emit("delete", payload);
    },
    editItem(payload) {
      this.$emit("edit", payload);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/suppliers/discounts/DiscountsTable.vue